<fin-mmb-purchase-success
  *ngIf="(orderStatus$ | async) !== OrderStatus.PENDING; else loader"
  [order$]="order$"
  [paymentMethods$]="paymentMethods$"
  [orderStatus$]="orderStatus$"
  (loadOrderErrorClick)="queueOrderLoad()"
></fin-mmb-purchase-success>

<ng-template #loader>
  <div class="align-center fill">
    <fin-loader [type]="LoaderType.INLINE"></fin-loader>
  </div>
</ng-template>
